import { ComponentProps, FormEvent, ReactElement } from 'react'

interface CheckboxProps extends ComponentProps<'input'> {
  onChange: (e: FormEvent<HTMLInputElement>) => void
  checked?: boolean
  label?: string
  labelLeft?: boolean
  labelClassName?: string
}

/**
 * @component
 * @param {Object} props
 * @param {Boolean} props.checked - Indicates if checkbox's state
 * @param {Function} props.onChange - Update checked state of the checkbox
 * @param {String} props.label - Label of the checkbox
 * @param {String} props.labelLeft - Indicates position of the label
 *
 * @returns {ReactElement}
 */
const Checkbox = ({
  id,
  name,
  checked,
  onChange,
  label,
  labelLeft,
  labelClassName,
}: CheckboxProps): ReactElement => {
  return (
    <div className="flex items-center">
      {labelLeft && (
        <label
          htmlFor={id}
          className={`me-2 cursor-pointer text-sm font-medium text-gray-900 dark:text-gray-300 ${labelClassName || ''}`}
        >
          {label}
        </label>
      )}
      <input
        name={name}
        checked={checked}
        onChange={onChange}
        id={id}
        type="checkbox"
        className="h-4 w-4 cursor-pointer rounded accent-primary"
      />
      {!labelLeft && (
        <label
          htmlFor={id}
          className={`ms-2 cursor-pointer text-sm font-medium text-gray-900 dark:text-gray-300 ${labelClassName || ''}`}
        >
          {label}
        </label>
      )}
    </div>
  )
}

export default Checkbox
